import Price from '../../ui/price'
import { useNavigate } from 'react-router-dom'
import { Cookies } from 'react-cookie'
import axios from 'axios'
import { makeNumbersFarsi } from '../../utils/farsi'
import { API_BASE_URL } from 'config/api'
import { getProductImageUrl, getImageAlt } from 'utils/imageUtils'
import { ProductImage } from 'utils/imageUtils'

// const BOOKSTORY_API_URL = 'https://api.gobookstory.com'

interface Product {
  image?: string | ProductImage // Old format: string, or Cart/Order format: ProductImage object
  images?: ProductImage[] // New format: array of image objects
  title: string
}

interface StatusHistoryType {
  status: string
  changedAt: string | number | Date
}

interface OrderItems {
  discount: number
  id: string
  orderId: string
  ownerId: string
  product: Product
  productId: string
  quantity: number
  price: number
  shipmentTrackingCode: number | null
  status: string
  statusHistory: StatusHistoryType[]
  subTotal: number
  total: number
  vat: number
}

const STATUS_LITERALS = {
  checkout: 'پرداخت نشده',
  'payment-succeed': 'در حال پردازش و بسته‌بندی',
  'partially-fulfilled': 'بخشی از سفارش پردازش شد',
  fulfilled: 'آماده‌ی ارسال',
  'partially-shipped': 'بخشی از سفارش ارسال شد',
  shipped: 'ارسال شد',
  completed: 'دریافت شده توسط گیرنده',
  declined: 'رد شد',
}

interface OrderItemProps {
  orderItem: OrderItems
}
interface OrderStatusTypes {
  checkout?: string
  'payment-succeed'?: string
  'partially-fulfilled'?: string
  fulfilled?: string
  'partially-shipped'?: string
  shipped?: string
  completed?: string
  declined?: string
}

export const OrderItem: React.FC<OrderItemProps> = ({ orderItem }) => {
  const navigate = useNavigate()
  const cookies = new Cookies()
  const token = cookies.get('@bookstory-auth-token')
  const authToken = token?.user?.authToken
  let userToken = authToken?.accessToken

  const renderItemImage = (orderItem: {
    product: Product
  }) => {
    const imageUrl = getProductImageUrl(orderItem.product, true) // Use thumbnail for order items

    if (imageUrl) {
      const firstImage = Array.isArray(orderItem.product.images)
        ? orderItem.product.images[0]
        : typeof orderItem.product.image === 'object' && orderItem.product.image !== null
          ? (orderItem.product.image as ProductImage)
          : undefined
      return (
        <img
          alt={getImageAlt(firstImage?.alt, orderItem.product.title, 0)}
          title={firstImage?.title || getImageAlt(firstImage?.alt, orderItem.product.title, 0)}
          className='w-24 ml-8 rounded-md'
          src={imageUrl}
          loading='lazy'
        />
      )
    }

    return null
  }

  const renderItemTitle = (orderItem: { product: { title: any } }) => {
    let title = orderItem.product.title

    return <h3 className='mt-2 md:mt-0'>{title}</h3>
  }

  const changeOrderItemStatus = async () => {
    let orderId = orderItem.orderId
    let orderItemIds = orderItem.id
    let data = {
      status: 'completed',
      orderItemIds: orderItemIds,
    }
    const config = {
      method: 'PUT',
      data: data,
      url: `${API_BASE_URL}/customer/orders/${orderId}/items`,
      headers: {
        Authorization: 'bearer ' + userToken,
      },
    }
    await axios(config).then((res) => {
      if (res.status === 200) navigate('/orders')
    })
  }

  return (
    <li className='order-item' key={orderItem.id}>
      <div className='flex flex-col md:flex-row items-start md:items-center'>
        <div className='flex flex-col md:flex-row items-center justify-center mx-0 my-2 md:my-0 md:mx-4'>
          {renderItemImage(orderItem)}
          {renderItemTitle(orderItem)}
        </div>

        <div className='price'>
          <Price
            value={orderItem.price}
            alternativeCurrencyCode={true}
            currencyCode={undefined}
          />
        </div>
      </div>
      {/* <div className='mt-3'>
        <div className='my-4'>
          <strong>آخرین وضعیت: </strong>
          {STATUS_LITERALS[orderItem.status as keyof OrderStatusTypes]}
        </div>

        {orderItem.shipmentTrackingCode && (
          <div className='my-4'>
            <strong>کد رهگیری پستی: </strong>
            {makeNumbersFarsi(orderItem.shipmentTrackingCode)}
          </div>
        )}
        {orderItem.status === 'completed' ||
        orderItem.status === 'payment-succeed' ? null : (
          <input
            onClick={changeOrderItemStatus}
            type='submit'
            className='bg-[#5E81AC] p-4 my-4 rounded flex items-center justify-center text-white w-1/4'
            value='محصول به دستم رسید'
          />
        )}
      </div> */}
    </li>
  )
}
